// BodyPage.jsx
import React from "react";
import "./Body.css";
import construction from "./images/construction.png";
import consultancy from "./images/consultancy.png";
import subcontract from "./images/sub-contract.png";

const Body = () => {
  const turnoverData = [
    { year: "2021-22", amount: "4.41Cr" },
    { year: "2022-23", amount: "6.24Cr" },
    { year: "2023-24", amount: "12.26Cr" },
    { year: "2024-25", amount: "15.15Cr" },
  ];

  return (
    <div className="body-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">
            Welcome to WCPL Workmates Private Limited
          </h1>
          <p className="hero-subtitle">
            Connecting colleagues, building community
          </p>
          <a href="/contactus">
            <button className="cta-button">Join Now</button>
          </a>
        </div>
        <div className="hero-image">
          <div className="floating-card">
            <div className="card-content">
              <h3>Team Collaboration</h3>
              <p>Work together seamlessly</p>
            </div>
          </div>
          <div className="floating-card card-2">
            <div className="card-content">
              <h3>Project Management</h3>
              <p>Track progress efficiently</p>
            </div>
          </div>
        </div>
      </section>

      <div className="services-container">
        <h1 className="services-title">OUR SERVICES</h1>

        <div className="services-row">
          {/* Construction Section */}
          <div className="service-section">
            <div className="construction-image">
              <img src={construction} alt="Construction Services" />
            </div>
            <h2 className="service-heading">CONSTRUCTION</h2>
            <ul className="service-list">
              <li>Pipeline Distribution Network (PDN)</li>
              <li>Canal Earthwork and Structures</li>
              <li>Lift Irrigation Scheme (LIS)</li>
              <li>Flood Protection Walls</li>
              <li>Gabion Structures</li>
              <li>Micro Irrigation Schemes</li>
              <li>CADWM Work</li>
              <li>Real Estate Projects</li>
              <li>Industrial Shead's</li>
              <li>Industrial Infrastructures</li>
            </ul>
          </div>

          {/* Consultancy Section */}
          <div className="service-section">
            <div className="consultancy-image">
              <img src={consultancy} alt="Consultancy Services" />
            </div>
            <h2 className="service-heading">CONSULTANCY</h2>
            <ul className="service-list">
              <li>Survey (Drone-GIS-DGPS-TS)</li>
              <li>Feasibility Study Reports</li>
              <li>Design of Lift Irrigation Scheme</li>
              <li>Pipe Distribution Network</li>
              <li>Micro Irrigation Projects</li>
              <li>Emergency Action Plan</li>
              <li>Hydraulic Studies of Projects</li>
              <li>Detailed Engineering Services</li>
              <li>Formation of Water User Association</li>
              <li>Capacity Building of WUA</li>
              <li>All types of Estimation</li>
              <li>Project Management Consultancy</li>
            </ul>
          </div>

          {/* Sub-Contracts Section */}
          <div className="service-section">
            <div className="subcontracts-image">
              <img src={subcontract} alt="Sub-Contract Services" />
            </div>
            <h2 className="service-heading">SUB-CONTRACTS</h2>
            <p className="service-description">
              WCPL Workmates (P) Ltd. provide our clients with a personalized
              general Sub-contracting service, bringing together the resources,
              expertise, and leadership needed for the successful and timely
              delivery of Irrigation, industrial infrastructure, Real estate
              projects through sub-contracts and completed successfully.
            </p>
          </div>
        </div>
      </div>

      {/* Resources section */}
      <section className="resources">
        <h2 className="resources-title">Resources Available with us</h2>

        <div className="circle-center">
          {/* Top Left - Office Staff */}
          <div className="quarter top-left-q">
            {/* <img src={officeIcon} alt="Office Staff" className="circle-icon" /> */}
            <h3 className="circle-heading">Office Staff</h3>
            <p className="circle-text">
              Project Managers, Hydraulic Designers, Planning and Design
              engineers, Accountant, Purchase officers, legal executive, AutoCAD
              draftsmen, AutoCAD Draftsman's, Accountant, PRO
            </p>
          </div>

          {/* Top Right - Site Staff */}
          <div className="quarter top-right-q">
            {/* <img src={siteIcon} alt="Site Staff" className="circle-icon" />0 */}
            <h3 className="circle-heading">Site Staff</h3>
            <p className="circle-text">
              Experienced Technical Personnels, Civil Engineers (BE/DCE),
              Surveyors (ITI/DCE), Graduation Degree holders Supervisors & site
              engineers.
            </p>
          </div>

          {/* Bottom Left - Software */}
          <div className="quarter bottom-left-q">
            {/* <img src={softwareIcon} alt="Software" className="circle-icon" /> */}
            <h3 className="circle-heading">Software</h3>
            <p className="circle-text">
              Auto-Cad, E-Survey, KY Pipe, HEC-RAS, water gems, stadpro,
              primavera, msp, ms office etc.
            </p>
          </div>

          {/* Bottom Right - Equipment */}
          <div className="quarter bottom-right-q">
            {/* <img src={equipmentIcon} alt="Equipment" className="circle-icon" /> */}
            <h3 className="circle-heading">Equipment/Machinery</h3>
            <p className="circle-text">
              DGPS, Total Stations, Drones, All types of construction
              equipment’s, Jointing machines, Generators, drilling grouting
              equipment’s, QC equipment's, Utility Vehicles, cameras, projectors
              etc.
            </p>
          </div>
        </div>
      </section>


      {/* Features Section */}
      <section className="features-section">
        <h2 className="section-title">Our Features</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">
              <i className="fas fa-users"></i>
            </div>
            <h3>Team Directory</h3>
            <p>Easily find and connect with colleagues across departments.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">
              <i className="fas fa-calendar-alt"></i>
            </div>
            <h3>Event Calendar</h3>
            <p>Stay updated with company events, meetings, and deadlines.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">
              <i className="fas fa-project-diagram"></i>
            </div>
            <h3>Project Hub</h3>
            <p>Collaborate on projects with integrated tools and resources.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">
              <i className="fas fa-comments"></i>
            </div>
            <h3>Discussion Forums</h3>
            <p>Share ideas and get feedback from your coworkers.</p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-content">
          <h2>Ready to Join Our Work Community?</h2>
          <p>Sign up today and start connecting with your colleagues</p>
          <div className="cta-buttons">
            <button className="cta-primary">Create Account</button>
            <button className="cta-secondary">Learn More</button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Body;
